import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { invoiceReceiptDateTime, formatDecimal } from 'utils/formatter';
import styles from './style.css';

class LoyaltyInfo extends Component {
  render() {
    const { loyalty, memberPhone } = this.props;
    return (
      <div className={`${styles['receipt-loyalty-info']}`}>
        <div>
          <div className={`${styles.title} pull-left`}>Loyalty Program</div>
          <div className="clearfix" />
        </div>
        <div>
          <span className="pull-left">Member Since</span>
          <span className="pull-right">
            {invoiceReceiptDateTime(loyalty.member_since, 'date')}
          </span>
          <span className="clearfix" />
        </div>
        <div>
          <span className="pull-left">Member Number</span>
          <span className="pull-right">{memberPhone}</span>
          <span className="clearfix" />
        </div>
        <div className="top20">
          {this.props.isUnpaidInvoiceEarningPoints ? (
            <div style={{ opacity: '0.8', fontSize: '12px' }}>
              Member can earn{' '}
              {formatDecimal(
                loyalty.new_earned_points + loyalty.new_member_points
              )}{' '}
              points after the invoice payment is fully paid.
            </div>
          ) : (
            <div>
              <div className="pull-left">Loyalty Program</div>
              <div className="clearfix" />
              <div className={`${styles['loyalty-info-detail']}`}>
                <div>
                  <span className="pull-left">Current Balance</span>
                  <span className="pull-right">
                    {formatDecimal(loyalty.current_balance)}
                  </span>
                  <span className="clearfix" />
                </div>
                {Boolean(loyalty.new_member_points) && (
                  <div>
                    <span className="pull-left">New Member Points</span>
                    <span className="pull-right">
                      {formatDecimal(loyalty.new_member_points)}
                    </span>
                    <span className="clearfix" />
                  </div>
                )}
                <div>
                  <span className="pull-left">New Earned Points</span>
                  <span className="pull-right">
                    {formatDecimal(loyalty.new_earned_points)}
                  </span>
                  <span className="clearfix" />
                </div>
                <div>
                  <span className="pull-left">Redeemed in This Purchase</span>
                  <span className="pull-right">
                    {formatDecimal(
                      loyalty.redemption ? loyalty.redemption.redeem_points : 0
                    )}
                  </span>
                  <span className="clearfix" />
                </div>
                <div>
                  <span className="pull-left">Closing Balance</span>
                  <span className="pull-right">
                    {formatDecimal(loyalty.closing_balance)}
                  </span>
                  <span className="clearfix" />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

LoyaltyInfo.propTypes = {
  loyalty: PropTypes.object,
};

export default LoyaltyInfo;
